import { createContext, useContext } from 'react'

/**
 * Provides the panel's stable value→color map to every chart strategy and
 * the legend table without prop-drilling through intermediate interfaces.
 *
 * Container.tsx wraps its chart and legend renders with the Provider and
 * supplies the result of useStableBreakdownColorMap.
 *
 * Consumers that have no Provider ancestor (e.g. in tests or isolated
 * Storybook stories) receive an empty Map, which causes the fallback
 * colour-assignment paths (buildBreakdownColorMap / positional palette)
 * to activate as before.
 */
export const BreakdownColorMapContext = createContext<Map<string, string>>(
  new Map(),
)

/**
 * Returns the stable value→color map for the current panel's primary
 * breakdown.  Must be called inside a component rendered beneath a
 * BreakdownColorMapContext.Provider.
 */
export function useBreakdownColorMap(): Map<string, string> {
  return useContext(BreakdownColorMapContext)
}
